import { CSSObject, DefaultTheme } from "styled-components";
import { useTheme } from "../../../assets/theme/ThemeProvider";

interface DisplayDataStyles {
    bold: CSSObject;
    label: CSSObject;
    data: CSSObject;
    flex: CSSObject;
    row: CSSObject;
    attachmentContainer: CSSObject;
    attachmentImage: CSSObject;
    attachmentLink: CSSObject;
    sectionHeader: CSSObject;
}

const useDisplayDataStyles = (): DisplayDataStyles => {
    const theme: DefaultTheme = useTheme();
    return {
        bold: {
            fontWeight: 'bold',
        },
        label: {
            fontSize: theme.spaceUnits.sp03,
            paddingRight: theme.spaceUnits.sp01,
            whiteSpace: "normal",
            paddingBottom: 0,
            marginBottom: 0
        },
        data: {
            whiteSpace: "normal",
        },
        flex: {
            display: "flex",
        },
        row: {
            marginBottom: theme.spacePx.sp03,
        },
        attachmentContainer: {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacePx.sp02,
            marginTop: theme.spacePx.sp01,
        },
        attachmentImage: {
            width: "80px",
            height: "80px",
            objectFit: "cover",
            display: "block",
            border: `1px solid ${theme.palette.divider.light}`,
            borderRadius: theme.spacePx.sp01,
        },
        attachmentLink: {
            display: "inline-flex",
            alignItems: "center",
            gap: theme.spacePx.sp01,
            fontSize: theme.font.sizes.sm,
            color: theme.palette.link.main,
            textDecoration: "none",
            fontWeight: theme.font.weights.regular,
        },
        sectionHeader: {
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.bold,
            color: theme.palette.text.dark,
            borderBottom: `2px solid ${theme.palette.divider.light}`,
            paddingBottom: theme.spacePx.sp01,
            marginBottom: theme.spacePx.sp02,
            display: "flex",
            alignItems: "center",
            gap: theme.spacePx.sp01,
            marginTop: theme.spacePx.sp03,
        },
    };
};

export default useDisplayDataStyles;
